import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { isThirdPartyField, productFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import {
  fuelCombustionReasonField,
  fuelConsumptionQuantityField,
  fuelKindField,
  rawFuelUnitField,
} from './common/fuelFields';
import { vehicleTypeField } from './common/travelFields';

export const fuelCombustionMetadata = {
  displayName: msg({
    message: 'Fuel combustion',
    context: 'Activity data schema name for fuel combustion',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    fuel_combustion_method: {
      displayName: msg({
        message: 'Fuel combustion method',
        context: 'The method of fuel combustion.',
      }),
    },
    fuel_combustion_reason: fuelCombustionReasonField,
    fuel_kind: fuelKindField,
    is_third_party: isThirdPartyField,
    quantity: fuelConsumptionQuantityField,
    unit: rawFuelUnitField,
    vehicle_type: vehicleTypeField,
  },
} as const satisfies BatMetadataConfigEntry;
